import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Modal from "react-modal";
import {
  // attendanceGet,
  // attendanceTrainerGet,
  gymDashBoardReportsGet,
} from "../../../data/ApiEndpoints";
import { fetchApiDataDup } from "../../../redux/reducers/commonApiSlice";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import TableFilters from "./TableFilters";
import TabsViewTable from "../tables/TabsViewTable";
import {
  convertStraight,
  convertTimeHHMMSS,
  currentMonthCurrentDate,
  currentMonthEndDate,
  currentMonthStartDate,
  currentMonthTomorrowDate,
  currentMonthYesterdayDate,
  currentYear,
  formatTimezoneThenStraight1,
  IS_LAST_DAY_OF_THE_MONTH,
  nextMonthEndDateFormatted,
} from "../../../components/common-data/Converts";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import { formatNumber } from "../../../utils/utilityfunc";
import TabViewCheckins from "../tables/TabViewCheckins";
import {
  currentMonth,
  pre_gym_sales,
  subscriptionTypes,
} from "../../../components/common-data/DropdowData";
import ModalHeadAndClose from "../../../components/payouts-wtf/common/ModalHeadAndClose";
import AddLeadForm from "../../../components/lead-management/AddLeadForm";
import LeadFollowupV1 from "../../../components/lead-management/followup/LeadFollowupV1";
import CommonStructured from "../../../components/common-components/CommonStructured";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  CallIcon,
} from "../../../images/icons/icons";
import LeadJourney from "../../../components/lead-management/lms-v2/lead-journey/LeadJourney";
import ClickToCall from "../../../components/lead-management/lms-v2/lms-payment-links/ClickToCall";
import { isManagerRole as checkIsManagerRole, isSingleGymUser } from "../../../components/common-data/Conversions";

const SalesCard = ({
  user,
  clickedCard,
  prevSelGym,
  prevPrevAllFilters,
  isURE,
  isUPMembersPage,
  cardName,
  isPreSale,
}) => {
  const dispatch = useDispatch();
  const { dataDup, loadingDup, errorDup } = useSelector(
    (state) => state.common
  );

  const apiCallRefs = useRef([]);

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(user);
  const selEndDate =
    isURE && prevPrevAllFilters && prevPrevAllFilters.selEndDate
      ? new Date(prevPrevAllFilters.selEndDate)
      : "";
  const selEndYear = isURE && selEndDate ? selEndDate.getFullYear() : "";
  const selEndMonth = isURE && selEndDate ? selEndDate.getMonth() + 1 : "";
  const isCurrentMonth =
    isURE && prevPrevAllFilters && prevPrevAllFilters.selEndDate
      ? Number(currentYear) === selEndYear && currentMonth === selEndMonth
      : "";

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  const extractCheckinTimes = (checkinArray) => {
    let last_checkin_start_end_time = [];

    checkinArray?.length > 0 &&
      checkinArray.forEach((item) => {
        const itemValue = item.value;
        last_checkin_start_end_time.push(itemValue);
      });

    return {
      last_checkin_start_end_time: last_checkin_start_end_time.join(", "),
    };
  };

  const extractExpiredDaysAgo = (arr) => {
    let days_ago = [];

    arr?.length > 0 &&
      arr.forEach((item) => {
        const itemValue = item.value;
        days_ago.push(itemValue);
      });

    return {
      days_ago: days_ago.join(", "),
    };
  };

  const extractPaymentTimes = (arr) => {
    let payment_times = [];

    arr?.length > 0 &&
      arr.forEach((item) => {
        const itemValue = item.value;
        payment_times.push(itemValue);
      });

    return {
      payment_times: payment_times.join(", "),
    };
  };

  const extractGyms = (arr) => {
    let gyms = [];

    arr?.length > 0 &&
      arr.forEach((item) => {
        const itemValue = item.value;
        gyms.push(itemValue);
      });

    return {
      gyms: gyms.join(", "),
    };
  };

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniTbDatas = {
    allData: null,
    pagination: [],
    totalSale: 0,
    totalMembers: 0,
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const { sales_data } = tbDatas.allData || {};

  const iniAllFilters = {
    selectedGym: prevSelGym
      ? prevSelGym
      : !isAdmin && !isManagerRole
      ? // For trainer / gym-owner, the user object carries the correct gym_id
        // (trainer: users.gym_id; gym owner: users.uid IS the gym_id).
        // For receptionist, the user object does NOT carry their assigned
        // gym (it lives in receptionist_master) → leave selectedGym empty
        // and let the backend's enforceGymAccess helper auto-restrict.
        isSingleGymUser(user) && user?.account_type === "receptionist"
        ? ""
        : {
            label: isGym ? user?.name : user?.gym_name || "",
            value: user?.gym_id || user?.uid || user?.user_id || "",
          }
      : "",
    selectedGyms: [],
    selAddedby: prevPrevAllFilters?.selAddedby
      ? prevPrevAllFilters.selAddedby
      : "",
    selectedOtherUsers:
      (clickedCard === "expiring_this_month" ||
        clickedCard === "unpaid_members" ||
        clickedCard === "expiring_today") &&
      prevPrevAllFilters?.selectedOtherUsers
        ? prevPrevAllFilters.selectedOtherUsers
        : "",
    selectedStartDate:
      clickedCard === "active_members"
        ? ""
        : clickedCard === "today" ||
          clickedCard === "regular" ||
          clickedCard === "addon_pt" ||
          clickedCard === "addon" ||
          clickedCard === "expiring_today" ||
          clickedCard === "checkins"
        ? currentMonthCurrentDate
        : (clickedCard === "expiring_this_month" && !isURE) ||
          (clickedCard === "expiring_this_month" && isURE && isCurrentMonth)
        ? currentMonthTomorrowDate
        : prevPrevAllFilters?.selStartDate
        ? prevPrevAllFilters.selStartDate
        : currentMonthStartDate,
    selectedEndDate:
      clickedCard === "active_members"
        ? ""
        : (clickedCard === "expiring_this_month" && !isURE) ||
          (clickedCard === "expiring_this_month" && isURE && isCurrentMonth)
        ? IS_LAST_DAY_OF_THE_MONTH
          ? nextMonthEndDateFormatted
          : currentMonthEndDate
        : clickedCard === "expiring_today"
        ? currentMonthCurrentDate
        : (clickedCard === "unpaid_members" && !isURE) ||
          (clickedCard === "unpaid_members" && isURE && isCurrentMonth)
        ? currentMonthYesterdayDate
        : prevPrevAllFilters?.selEndDate
        ? prevPrevAllFilters.selEndDate
        : currentMonthCurrentDate,
    selectedTrxMode: "",
    selectedSubsType:
      cardName === "regular_sales_today"
        ? subscriptionTypes[0]
        : cardName === "pt_sales_today"
        ? subscriptionTypes[2]
        : "",
    selectedPlan: "",
    selectedRole: "",
    selRecurringStatus: "",
    selExpiringInDays: "",
    lastCheckedIn: "",
    selLeastCheckinInBetween: [],
    searchString: "",
    selExpiredDaysAgo: [],
    selButtonEnabled: "",
    selAddNotAddToLead: "",
    selPaymentTimeSlot: [],
    selPaymentSource: "",
    selectedPreGymSales:
      cardName === "pre_gym_sales_today" || isPreSale
        ? pre_gym_sales[1]
        : cardName === "regular_gym_sales_today"
        ? pre_gym_sales[2]
        : "",
    selectedPriceRangeFrom: "",
    selectedPriceRangeTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);

  const iniTbFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    cluster_manager_id: allFilters.selAddedby?.value || "",
    sub_added_by: allFilters?.selectedOtherUsers?.value || "",
    filter_type:
      clickedCard === "regular" ||
      clickedCard === "addon_pt" ||
      clickedCard === "addon"
        ? "today"
        : clickedCard === "active_members"
        ? "active"
        : clickedCard === "unpaid_members"
        ? "unpaid"
        : clickedCard === "expiring_today"
        ? "expire_today"
        : clickedCard === "expiring_this_month"
        ? "expire_month"
        : clickedCard,
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    trx_id: allFilters.selectedTrxMode?.value || "",
    membership_type:
      clickedCard === "regular" ||
      clickedCard === "addon_pt" ||
      clickedCard === "addon"
        ? clickedCard
        : allFilters.selectedSubsType?.value
        ? allFilters.selectedSubsType.value
        : "",
    plan_duration: allFilters.selectedPlan?.value
      ? allFilters.selectedPlan.value
      : "",
    addon_cat_id:
      allFilters.selectedSubsType?.value === "addon" &&
      allFilters.selectedPlan?.value
        ? allFilters.selectedPlan.value
        : "",
    account_type: allFilters.selectedRole?.value || "",
    is_recurring: allFilters.selRecurringStatus?.value || "",
    last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
    expiring_indays: allFilters.selExpiringInDays?.value || "",
    is_btn_enabled: allFilters.selButtonEnabled?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    payment_time_slot: "",
    payment_source: allFilters.selPaymentSource?.value || "",
    is_pre_sale: allFilters.selectedPreGymSales?.value || "",
    price_range_from: allFilters.selectedPriceRangeFrom?.value || "",
    price_range_to: allFilters.selectedPriceRangeTo?.value || "",
  };
  const [tbFilters, setTbFilters] = useState(iniTbFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const isBroadcastMode = modValues.modName === "broadcast_data";

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setTbFilters(iniTbFilters);
    setIsPage(0);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setTbFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getCardDetails(tbFilters) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: gymDashBoardReportsGet,
        payload: {
          filters: tbFilters,
        },
        token: user?.token,
      })
    );
  }

  const registerApiCall = (apiCall) => {
    if (!apiCallRefs.current.includes(apiCall)) {
      apiCallRefs.current.push(apiCall);
    }
  };

  const handleReload = () => {
    apiCallRefs.current.forEach((apiCall) => apiCall());
  };

  useEffect(() => {
    setAllFilters((prev) => {
      if (!prev.selectedGym) return prev;

      const filtered = prev.selectedGyms.filter(
        (gym) => gym?.value !== prev.selectedGym?.value
      );

      return {
        ...prev,
        selectedGyms: [prev.selectedGym, ...filtered],
      };
    });
  }, [allFilters.selectedGym]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: prevSelGym
  //       ? prevSelGym
  //       : !isAdmin
  //       ? {
  //           label: isGym ? user?.name : user?.gym_name || "",
  //           value: user?.gym_id || user?.uid || user?.user_id || "",
  //         }
  //       : "",
  //   }));
  // }, [user?.gym_id]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selAddedby: prevPrevAllFilters?.selAddedby || "",
    }));
  }, [prevPrevAllFilters?.selAddedby]);

  useEffect(() => {
    const { last_checkin_start_end_time } = extractCheckinTimes(
      allFilters.selLeastCheckinInBetween
    );
    const { days_ago } = extractExpiredDaysAgo(allFilters.selExpiredDaysAgo);

    const { payment_times } = extractPaymentTimes(
      allFilters.selPaymentTimeSlot
    );

    const shouldUseMultipleGyms = isBroadcastMode;
    const { gyms } = shouldUseMultipleGyms
      ? extractGyms(allFilters.selectedGyms)
      : { gyms: "" };
    const gymId = shouldUseMultipleGyms
      ? gyms || allFilters.selectedGym?.value || ""
      : allFilters.selectedGym?.value || "";

    setTbFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: gymId,
      cluster_manager_id: allFilters.selAddedby?.value || "",
      sub_added_by: allFilters?.selectedOtherUsers?.value || "",
      filter_type:
        clickedCard === "regular" ||
        clickedCard === "addon_pt" ||
        clickedCard === "addon"
          ? "today"
          : clickedCard === "active_members"
          ? "active"
          : clickedCard === "unpaid_members"
          ? "unpaid"
          : clickedCard === "expiring_today"
          ? "expire_today"
          : clickedCard === "expiring_this_month"
          ? "expire_month"
          : clickedCard,
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      trx_id: allFilters.selectedTrxMode?.value || "",
      membership_type:
        clickedCard === "regular" ||
        clickedCard === "addon_pt" ||
        clickedCard === "addon"
          ? clickedCard
          : allFilters.selectedSubsType?.value
          ? allFilters.selectedSubsType.value
          : "",
      plan_duration: allFilters.selectedPlan?.value
        ? allFilters.selectedPlan.value
        : "",
      addon_cat_id:
        allFilters.selectedSubsType?.value === "addon" &&
        allFilters.selectedPlan?.value
          ? allFilters.selectedPlan.value
          : "",
      account_type: allFilters.selectedRole?.value || "",
      is_recurring: allFilters.selRecurringStatus?.value || "",
      last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
      last_checkin_time_filter: last_checkin_start_end_time || "",
      expiring_indays: allFilters.selExpiringInDays?.value || "",
      expired_days_ago: days_ago || "",
      is_btn_enabled: allFilters.selButtonEnabled?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      payment_time_slot: payment_times || "",
      payment_source: allFilters.selPaymentSource?.value || "",
      is_pre_sale: allFilters.selectedPreGymSales?.value || "",
      price_range_from: allFilters.selectedPriceRangeFrom?.value || "",
      price_range_to: allFilters.selectedPriceRangeTo?.value || "",
    }));
  }, [
    clickedCard,
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedGyms,
    allFilters.selAddedby,
    allFilters?.selectedOtherUsers,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.selectedTrxMode,
    allFilters.selectedSubsType,
    allFilters.selectedPlan,
    allFilters.selectedRole,
    allFilters.selRecurringStatus,
    allFilters.lastCheckedIn,
    allFilters.selExpiringInDays,
    allFilters.selLeastCheckinInBetween,
    allFilters.selExpiredDaysAgo,
    allFilters.selButtonEnabled,
    allFilters.selAddNotAddToLead,
    allFilters.selPaymentTimeSlot,
    allFilters.selPaymentSource,
    allFilters.selectedPreGymSales,
    isBroadcastMode,
    allFilters.selectedPriceRangeFrom,
    allFilters.selectedPriceRangeTo,
  ]);

  useEffect(() => {
    if (tbFilters.filter_type && clickedCard !== "checkins") {
      getCardDetails(tbFilters);
    }
  }, [tbFilters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setTbFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (dataDup?.status && !errorDup) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: dataDup?.data,
        pagination: dataDup?.pagination?.length > 0 ? dataDup.pagination : [],
        totalSale: dataDup?.total ? dataDup.total : 0,
        totalMembers:
          dataDup?.pagination?.length > 0
            ? dataDup.pagination[0]?.pagination
            : 0,
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [dataDup, errorDup]);

  const tbColumns = [
    (clickedCard === "expiring_today" ||
      clickedCard === "expiring_this_month" ||
      clickedCard === "unpaid_members") && {
      dataField: "is_btn_enabled",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div className="actionButtonContainer">
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#C90808",
                color: "#fff",
                borderRadius: "8px",
                cursor: row?.is_btn_enabled ? "pointer" : "not-allowed",
                fontSize: "15px",
                padding: "10px",
                opacity: row?.is_btn_enabled ? 1 : 0.5,
              }}
              onClick={() =>
                row?.is_btn_enabled &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "add-to-lead",
                }))
              }
              disabled={!row?.is_btn_enabled}
            >
              Add To LMS
            </button>
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#000",
                color: "#fff",
                borderRadius: "8px",
                cursor: row?.added_to_lead ? "pointer" : "not-allowed",
                fontSize: "15px",
                padding: "10px",
                opacity: row?.added_to_lead ? 1 : 0.5,
              }}
              onClick={() =>
                row?.added_to_lead &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  // modName: "follow-up",
                  modName: "view-lead-journey",
                }))
              }
              disabled={!row?.added_to_lead}
            >
              View Lead
            </button>
          </div>
        );
      },
    },
    (clickedCard === "expiring_today" ||
      clickedCard === "expiring_this_month" ||
      clickedCard === "unpaid_members") && {
      dataField: "added_to_lead",
      text: "Added To Lead",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.added_to_lead ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150"
            style={{ textDecoration: "underline" }}
          >
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{
              minWidth: "150px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              rowGap: "7px",
            }}
          >
            <b>₹{formatNumber(row?.price || 0)}</b>
            <small>
              {row?.type === "regular" ? row?.plan_name : row?.addon_name || ""}
              <br />({row?.type ? row?.type?.replace(/_/g, " ") : ""})
            </small>
            <small
              style={{
                padding: "10px",
                borderRadius: "4px",
                color: "#fff",
                backgroundColor: row?.subs_reference_id ? "#0F67B1" : "#36BA98",
              }}
            >
              {row?.subs_reference_id ? "Recurring" : "Non Recurring"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row.date_added
              ? moment(new Date(parseInt(row.date_added)))
                  .tz("Asia/Kolkata")
                  .format("DD-MM-YYYY")
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.start_date
              ? formatTimezoneThenStraight1(row.start_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 bold"
            style={{ textDecoration: "underline" }}
          >
            {row?.expire_date
              ? formatTimezoneThenStraight1(row.expire_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "Subscription Status",
      formatter: (_, row) => {
        const expireDate = moment(row.expire_date).tz("Asia/Kolkata");
        const today = moment().tz("Asia/Kolkata");
        const isExpired = expireDate.isSameOrBefore(today);

        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8"
            style={{
              background:
                (row?.subscription_status &&
                  row?.subscription_status?.toLowerCase() !== "active") ||
                isExpired
                  ? "#F6EFEF"
                  : "#E2EFD5",
              color:
                (row?.subscription_status &&
                  row?.subscription_status?.toLowerCase() !== "active") ||
                isExpired
                  ? "#F13434"
                  : "#379C00",
            }}
          >
            {row?.subscription_status ? (
              row.subscription_status?.replace(/_/g, " ")
            ) : (
              <>
                {isExpired ? (
                  <span style={{ color: "red" }}>Expired</span>
                ) : (
                  <span style={{ color: "green" }}>Active</span>
                )}
              </>
            )}
          </span>
        );
      },
    },
    (clickedCard === "expiring_this_month" ||
      clickedCard === "unpaid_members") && {
      dataField: "subscription_expiry_days",
      text: `${
        clickedCard === "unpaid_members"
          ? `Expired Days Ago (Based On ${convertStraight(
              allFilters.selectedEndDate || currentMonthCurrentDate
            )})`
          : "Expiring In"
      }`,
      formatter: (_, row) => {
        let bgColor = "#E2EFD5";
        let textColor = "#379C00";

        const daysRemaining =
          clickedCard === "unpaid_members"
            ? parseInt(row?.expired_days_ago || 0)
            : parseInt(row?.subscription_expiry_days || 0);

        if (daysRemaining >= 1 && daysRemaining <= 5) {
          bgColor = "#F6EFEF";
          textColor = "#F13434";
        } else if (daysRemaining > 5 && daysRemaining <= 10) {
          bgColor = "#FFEEEF";
          textColor = "#D2000B";
        } else if (daysRemaining < 1) {
          bgColor = "#F6EFEF";
          textColor = "#F13434";
        }

        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8"
            style={{
              background:
                clickedCard === "unpaid_members" ? "#F6EFEF" : bgColor,
              color: clickedCard === "unpaid_members" ? "#F13434" : textColor,
            }}
            // style={{
            //   background: "#F6EFEF",
            //   color: "#F13434",
            // }}
          >
            {clickedCard === "unpaid_members"
              ? row?.expired_days_ago?.replace(/_/g, " ") || "-"
              : row?.subscription_expiry_days?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    (clickedCard === "expiring_this_month" ||
      clickedCard === "unpaid_members") && {
      dataField: "last_checkin_date",
      text: "Member Last Checkin",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.last_checkin_date
              ? convertStraight(row.last_checkin_date)
              : "-"}
            <br />
            <small>
              {row?.checkin_time ? convertTimeHHMMSS(row.checkin_time) : ""}
              <br />
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "trx_id",
      text: "Payment type",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.trx_id || "-"}</span>;
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Mode",
      formatter: (_, row) => {
        const pendingPayments = row.payment_details?.filter(
          (x) => x.status === "pending"
        );
        const pendingPaymentsCount = pendingPayments?.length || 0;

        return (
          <span
            className="tb-data"
            style={{
              textDecoration: row.is_partial === "true" ? "underline" : "none",
              fontWeight: row.is_partial === "true" ? "700" : "500",
              cursor: row.is_partial === "true" ? "pointer" : "default",
            }}
            // onClick={() =>
            //   row.is_partial === "true"
            //     ? onClickRow(row?.payment_details)
            //     : null
            // }
          >
            {row.is_partial === "true" ? "Partial" : "Full"}
            {row.is_partial === "true"
              ? `(${pendingPaymentsCount || 0})`
              : null}
          </span>
        );
      },
    },
    {
      dataField: "sub_added_by",
      text: "Sub Added By",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.sub_added_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.sub_added_by_mobile || ""}
              <br />
              {row?.sub_added_by_email || ""}
            </small>
          </span>
        );
      },
    },
    (clickedCard === "expiring_today" ||
      clickedCard === "expiring_this_month" ||
      clickedCard === "unpaid_members") && {
      dataField: "click_to_call",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "click-to-call",
                  rowData: row,
                }))
              }
            >
              <CallIcon color="#000" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "add-to-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : modValues.modName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : "add-new-lead-form"
          }`}
        >
          {modValues.modName === "add-to-lead" ||
          modValues.modName === "click-to-call" ? null : modValues.modName ===
            "view-lead-journey" ? (
            <ModalHeadAndClose
              title={`Lead Details - ${modValues.rowData?.user_name || ""}`}
              onClose={onCloseModal}
            />
          ) : (
            <ModalHeadAndClose title="Add To LMS" onClose={onCloseModal} />
          )}

          {modValues.modName === "add-to-lead" ? (
            <AddLeadForm
              userInfoData={user}
              closeModal={onCloseModal}
              callFunction={() => {
                if (tbFilters.filter_type && clickedCard !== "checkins") {
                  getCardDetails(tbFilters);
                }
              }}
              rowData={modValues.rowData}
              isURE={true}
              ureCard={
                clickedCard === "expiring_today" ||
                clickedCard === "expiring_this_month"
                  ? "expiring"
                  : clickedCard === "unpaid_members"
                  ? "unpaid"
                  : clickedCard
              }
            />
          ) : modValues.modName === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={user}
              rowData={modValues.rowData}
              closeFollowupModal={onCloseModal}
            />
          ) : modValues.modName === "view-lead-journey" ? (
            <LeadJourney userInfoData={user} rowData={modValues.rowData} />
          ) : modValues.modName === "click-to-call" ? (
            <ClickToCall
              userInfoData={user}
              closeModal={onCloseModal}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      {clickedCard === "active_members" ||
      clickedCard === "unpaid_members" ||
      clickedCard === "checkins" ? (
        <CommonStructured
          pageHeading={clickedCard?.replace(/_/g, " ")}
          isReload={() => {
            clickedCard === "checkins"
              ? handleReload()
              : getCardDetails(tbFilters);
          }}
        />
      ) : null}

      <TableFilters
        user={user}
        allFilters={allFilters}
        setAllFilters={setAllFilters}
        salesTodayValues={sales_data}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        onClickReset={onClickReset}
        clickedCard={clickedCard}
        canPlanFilters={
          clickedCard === "sales_month" ||
          clickedCard === "today" ||
          clickedCard === "unpaid_members"
            ? true
            : false
        }
        totalSaleData={
          clickedCard === "active_members" ||
          clickedCard === "unpaid_members" ||
          clickedCard === "expiring_today" ||
          clickedCard === "expiring_this_month"
            ? tbDatas.totalSale
            : null
        }
        totalMemberData={tbDatas.totalMembers}
        isActiveDate={clickedCard === "active_members" ? true : false}
        isUnpaidDate={clickedCard === "unpaid_members"}
        cardType={clickedCard}
        isDisableFutureDates={clickedCard === "unpaid_members"}
        filters={tbFilters}
        isUPMembersPage={isUPMembersPage}
        setModValues={setModValues}
        callFunction={() => getCardDetails(tbFilters)}
      />

      <>
        {clickedCard === "today" ||
        clickedCard === "sales_month" ||
        clickedCard === "regular" ||
        clickedCard === "addon_pt" ||
        clickedCard === "addon" ? (
          <div className="tab-view-table-container mt30">
            <TabsViewTable
              tbDatas={tbDatas}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              isOneDayTabShow={
                clickedCard === "today" || clickedCard === "sales_month"
              }
              clickedCard={clickedCard}
            />
          </div>
        ) : clickedCard === "active_members" ||
          clickedCard === "unpaid_members" ||
          clickedCard === "expiring_today" ||
          clickedCard === "expiring_this_month" ? (
          <>
            {loadingDup ? (
              <ReactVortoxSpinner />
            ) : (
              <div className="overflowAuto separatedTable">
                <PaymentLinkTable
                  tableData={tbDatas.allData}
                  tableColumns={tbColumns}
                  isPage={isPage}
                  setIsPage={setIsPage}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  tablePagination={tbDatas.pagination}
                />
              </div>
            )}
          </>
        ) : clickedCard === "checkins" ? (
          <div className="tab-view-table-container mt30">
            <TabViewCheckins
              user={user}
              clickedCard={clickedCard}
              tbFilters={tbFilters}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              registerApiCall={registerApiCall}
            />
          </div>
        ) : null}
      </>
    </>
  );
};

export default SalesCard;
